export default __webpack_public_path__ + "empty-search-md.2566c760.svg";